var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('oc-form-field',_vm._g(_vm._b({staticClass:"oc-table-cell-input",attrs:{"target":_vm.name,"auto-register-field":false,"input":_vm.inputType}},'oc-form-field',_vm.$_options,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }